import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FascicoloLight } from 'src/app/common/models/fascicolo/fascicolo-light';
import { RoutingConfigurationUtilService } from 'src/app/core/services/routing-configuration-util.service';
import { CssClassMapping } from '../../../../core/configuration/css-class-mapping';
import { FrontEndMapping } from '../../../../core/configuration/front-end-mapping';
import { ServicePathsSettings } from '../../../../core/configuration/service-paths-settings';
import { PraticaSelect } from "../../../models/pratica/intestazione-pratica/pratica-select";
import { PraticaBase } from '../../../models/pratica/pratica-base';
import { PraticaLight } from '../../../models/pratica/pratica-light';

@Component({
    selector: 'li [istanza-risultato_pratica]',
  templateUrl: 'istanza-risultato-pratica.html',
  styleUrls: ['./istanza-risultato-pratica.css'],
  host: { '[class.panel]': '\'true\'' }
})
export class IstanzaRisultatoPraticaComponent implements OnChanges {
  constructor(private frontEndMapping: FrontEndMapping, private routingService: RoutingConfigurationUtilService) {}
  copied: boolean;
  expandedMap: { [id: number]: boolean } = {};
  @Input()
  disableSelect: boolean;

  @Input()
  pratica: PraticaSelect;

  @Input()
  reset: boolean;

  @Input()
  praticaCopyInfo: PraticaSelect;

  @Input() location: string = '';

  @Output()
  onReturn: EventEmitter<PraticaBase> = new EventEmitter<PraticaSelect>();

  @Output()
  onReturnCopy: EventEmitter<PraticaBase> = new EventEmitter<PraticaSelect>();

  @Output()
  onNavigate: EventEmitter<boolean> = new EventEmitter<boolean>();


  ngOnChanges(changes: SimpleChanges): void {
    if (changes.reset && this.reset) {
      this.pratica.selected = false;
      this.praticaCopyInfo = null;
    }
  }

  getClassPratica(idTipoPratica) {
    return CssClassMapping.cssTipiPratica[idTipoPratica];
  }

  getPraticaPathFromType(pratica: PraticaLight) {
    let tipoPratica = '';
    this.frontEndMapping.getListTipiPratica(pratica.tipoPratica.id).subscribe(res => {
      tipoPratica = res;
    });
    return tipoPratica;
    // return FrontEndMapping.tipiPratica[pratica.tipoPratica.id];
  }

  getPraticaViewPath() {
    return ServicePathsSettings.VIEW_LABEL;
  }

  aggiungiPraticaPrecedente(pratica: PraticaSelect) {
    if (this.onReturn) {
      this.onReturn.emit(pratica);
    }
  }

  getRoutingPath(fascicolo, pratica): string {
    let path: string;
    path = this.routingService.checkStatoFascicoloAndGetRoutingPath(fascicolo, pratica.tipoPratica.id, fascicolo.tipoFascicolo.id);
    return path;
  }

  getCssClassCategoriaFascicolo(fascicolo: FascicoloLight) {
    if(fascicolo.tipoFascicolo && fascicolo.tipoFascicolo.categoria){   
      let categoriaMap = CssClassMapping.cssTipiCategoriaFascicolo[fascicolo.tipoFascicolo.categoria.id];
      return categoriaMap;
    }
  }

  copyInfoPratica(pratica: PraticaSelect) {
    if (this.onReturnCopy) {
      this.copied = true;
      this.onReturnCopy.emit(pratica);
    }
  }

  

  toggleSubpratica(id: string): void {
    this.expandedMap[id] = !this.expandedMap[id];
  }

  isExpanded(id: string): boolean {
    return !!this.expandedMap[id];
  }

}
